<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <div>
            <div>
                <div class="md:max-w-md mx-auto">
                    <WeeklyQuestMilestones :weekly-milestones="widget.content.weeklyMilestones" />
                </div>
            </div>

            <AppWell>
                <div class="md:grid md:grid-cols-2 md:gap-6">
                    <AppCard v-for="quest in widget.content.quests" :key="quest.id">
                        <div class="flex flex-col justify-between h-full">
                            <div class="text-sm">
                                {{ quest.text }}
                            </div>
                            <ProgressBar
                                :percent="Math.round((quest.progress.current / quest.progress.total) * 100)"
                                :color="quest.progress.current === quest.progress.total ? 'green' : 'blue'"
                                height="xs"
                                :show-text="false"
                                class="w-full opacity-75"
                            />
                        </div>
                    </AppCard>
                </div>
            </AppWell>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import WeeklyQuestMilestones from '@/Pages/Student/Gamification/Quests/partials/WeeklyQuestMilestones.vue';
import ProgressBar from '@/components/Gamification/ProgressBar.vue';

export default {
    name: 'MoodCheckWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        ProgressBar,
        WeeklyQuestMilestones,
        AppCard,
        AppWell,
        BaseWidget,
    },
    data() {
        return {
            form: this.$inertia.form({
                comment: null,
                mood_score: null,
            }),
            isSent: false,
        };
    },
    methods: {
        submit() {
            this.form.post(this.widget.content.url, {
                preserveScroll: true,
                onSuccess: () => {
                    this.isSent = true;
                },
            });
        },
    },
};
</script>
